function searchUrl(base, query) {
    return base + '?_product_keyword_search=' + encodeURIComponent(query);
}

function getAutocomplete() {
    const lib = window['@algolia/autocomplete-js'];
    return lib && lib.autocomplete ? lib.autocomplete : null;
}

function initHomeHeroAutocomplete(el) {
    const autocompleteFn = getAutocomplete();
    const apiUrl = el.dataset.apiUrl;
    const inventoryUrl = el.dataset.inventoryUrl;
    const machinesUrl = el.dataset.machinesUrl;
    const placeholder = el.dataset.placeholder || 'Search products & machines...';

    if (!autocompleteFn || !apiUrl || !inventoryUrl || !machinesUrl) {
        return;
    }

    autocompleteFn({
        container: el,
        placeholder: placeholder,
        openOnFocus: true,
        detachedMediaQuery: 'none',
        classNames: {
            panel: 'custom-autocomplete-panel',
        },
        onSubmit: function ({ event }) {
            event.preventDefault();
        },
        getSources: function ({ query }) {
            const sources = [];
            const trimmed = (query || '').trim();

            if (!trimmed.length) {
                return sources;
            }

            const responsePromise = trimmed.length >= 2
                ? fetch(apiUrl + '?search=' + encodeURIComponent(trimmed))
                    .then(function (res) { return res.json(); })
                    .catch(function () {
                        return {
                            hits: [],
                            has_products: false,
                            has_machines: false,
                        };
                    })
                : Promise.resolve(null);

            if (trimmed.length >= 2) {
                sources.push({
                    sourceId: 'results',
                    getItems: function () {
                        return responsePromise.then(function (data) {
                            return (data && data.hits) || [];
                        });
                    },
                    templates: {
                        item: function ({ item, html }) {
                            const badgeColor = item.post_type === 'kpc_product' ? '#007FB2' : '#F6B630';

                            return html`
                                <a href="${item.url}" class="autocomplete-result">
                                    <span class="autocomplete-result-text">${item.display}</span>
                                    <span class="autocomplete-result-badge" style="color: ${badgeColor};">
                                        ${item.type_label}
                                    </span>
                                </a>
                            `;
                        },
                        noResults: function ({ html }) {
                            return html`<div class="autocomplete-empty">No results found</div>`;
                        },
                    },
                    onSelect: function ({ item, setIsOpen }) {
                        window.location.href = item.url;
                        setIsOpen(false);
                    },
                });
            }

            sources.push({
                sourceId: 'quick_links',
                getItems: function () {
                    return responsePromise.then(function (data) {
                        if (!data) {
                            return [];
                        }

                        const links = [];

                        if (data.has_products) {
                            links.push({
                                label: 'View all inventory for "' + trimmed + '"',
                                url: searchUrl(inventoryUrl, trimmed),
                            });
                        }

                        if (data.has_machines) {
                            links.push({
                                label: 'View all dismantled machines for "' + trimmed + '"',
                                url: searchUrl(machinesUrl, trimmed),
                            });
                        }

                        return links;
                    });
                },
                templates: {
                    item: function ({ item, html }) {
                        return html`
                            <a href="${item.url}" class="autocomplete-link">
                                <span>${item.label}</span>
                            </a>
                        `;
                    },
                },
                onSelect: function ({ item, setIsOpen }) {
                    window.location.href = item.url;
                    setIsOpen(false);
                },
            });

            return sources;
        },
    });
}

document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.custom-autocomplete').forEach(initHomeHeroAutocomplete);
});
